import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { checkVersion } from "@/utils/versionCheck";

// Build info - UPDATE WITH EVERY DEPLOYMENT!
const BUILD_VERSION = '202611030901';
const BUILD_TIMESTAMP = new Date().toISOString();

// DEBUG: Log environment on startup
console.log('🚀 X-TREME CONCEPT App Starting...');
console.log('📡 Backend URL:', window.location.origin, '(runtime origin)');
console.log('🔧 Build Version:', BUILD_VERSION);
console.log('⏰ Build Time:', BUILD_TIMESTAMP);

// Check if app needs to refresh due to version change
checkVersion();

// Register Service Worker for PWA with auto-update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceWorker.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        
        // Check for updates every 60 seconds
        setInterval(() => {
          registration.update();
        }, 60000);
        
        // Listen for new service worker waiting
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          console.log('New service worker installing...');
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content is available, notify user or auto-refresh
              console.log('New content available! Refreshing...');
              
              // Auto-activate the new service worker
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
    
    // When the new service worker takes over, refresh the page
    // BUT: Skip reload if user is in the middle of authentication
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        
        // Check if we're on login/register page or just authenticated
        const isAuthPage = window.location.pathname.includes('/login') || 
                           window.location.pathname.includes('/register');
        const hasToken = localStorage.getItem('token');
        
        // Don't reload if user just logged in or is on auth page
        if (isAuthPage || (hasToken && Date.now() - (window.lastAuthTime || 0) < 5000)) {
          console.log('Service worker updated but skipping reload (authentication in progress)');
          return;
        }
        
        console.log('Service worker updated, reloading page...');
        window.location.reload();
      }
    });
    
    // Listen for custom sound messages from Service Worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'PLAY_CUSTOM_SOUND') {
        const soundUrl = event.data.soundUrl;
        console.log('📢 Playing custom notification sound:', soundUrl);
        
        // Create and play audio
        const audio = new Audio(soundUrl);
        audio.volume = 1.0;
        audio.play().catch((err) => {
          console.warn('Could not play custom sound:', err);
        });
      }
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
// Force rebuild 1771556739
